/**
 * Store Echange Clients
 */
export default {
    getters: {
        optionsCategorieEchange: () => {
            return [
                { value: 10, label: 'Entrant' },
                { value: 20, label: 'Sortant' }
            ]
        },

        optionsProvenanceEchange: () => {
            return [
                { value: 10, label: 'Appel standard' },
                { value: 20, label: 'Appel direct Inelys' },
                { value: 30, label: 'Mail' },
                { value: 40, label: 'Site web' }
            ]
        },

        optionsStatutEchange: () => {
            return [
                { value: 10, label: 'Non attribué' },
                { value: 20, label: 'Ouvert' },
                { value: 30, label: 'Clos' }
            ]
        },
    }
}
